module.exports = __webpack_public_path__ + "static/media/decor-problem2.651274f8.png";